<template>
  <v-container>
    <v-row justify="space-between">
      <h2 class="font-weight-thin">
        รายการบริการและบริการคอร์สของร้าน
      </h2>
      <v-btn
        large
        rounded
        color="orange"
        @click="bookDialog = true"
      >
        <v-icon left>
          fas fa-shopping-cart
        </v-icon>
        สิ้นค้าในตระกร้า {{ selectedCourse.length + selectedService.length }} ชิ้น
      </v-btn>
    </v-row>
    <v-container>
      <h3>รายการบริการคอร์ส</h3>
      <v-row>
        <v-col
          v-for="item in courses"
          :key="item._id"
          cols="12"
          sm="4"
          md="3"
        >
          <v-card>
            <v-img
              v-if="item.image"
              class="white--text"
              height="200px"
              :src="item.image"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-img
              v-else
              class="white--text"
              height="200px"
              src="https://firebasestorage.googleapis.com/v0/b/thesis-5b315.appspot.com/o/spa-manage%2Fplaceholder.jpg?alt=media"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-card-text>
              <span>เวลาที่ใช้: {{ item.time }} นาที</span><br>
              <span>ราคา: {{ item.price }} บาท</span><br>
              <span>บริการ: </span>
              <span
                v-for="(service, index) in item.services"
                :key="service._id"
              >
                {{ service.name }}<span v-if="index !== item.services.length - 1">,</span>
              </span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="orange"
                @click="addToCart(item, 'course')"
              >
                จองบริการนี้
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <h3>รายการบริการ</h3>
      <v-row>
        <v-col
          v-for="item in services"
          :key="item._id"
          cols="12"
          sm="4"
          md="3"
        >
          <v-card>
            <v-img
              v-if="item.image"
              class="white--text"
              height="200px"
              :src="item.image"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-img
              v-else
              class="white--text"
              height="200px"
              src="https://firebasestorage.googleapis.com/v0/b/thesis-5b315.appspot.com/o/spa-manage%2Fplaceholder.jpg?alt=media"
            >
              <v-card-title class="align-end fill-height">
                {{ item.name }}
              </v-card-title>
            </v-img>
            <v-card-text>
              <span>เวลาที่ใช้: {{ item.time }} นาที</span><br>
              <span>ราคา: {{ item.price }} บาท</span><br>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="orange"
                @click="addToCart(item, 'service')"
              >
                จองบริการนี้
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="bookDialog"
      max-width="600"
    >
      <v-card>
        <v-card-title>
          ตระกร้าสินค้า
          [ ราคารวม : {{ price ? price : '-' }} บาท ]
          [ ระยะเวลา :  {{ time ? time : '-' }} นาที ]
        </v-card-title>
        <v-card-text>
          <v-list
            subheader
            dense
            two-line
          >
            <v-subheader>บริการคอร์สที่คุณเลือก</v-subheader>
            <div v-if="selectedCourse.length > 0">
              <v-list-item
                v-for="course in selectedCourse"
                :key="course._id"
              >
                <v-list-item-avatar color="orange">
                  <v-img
                    v-if="course.image"
                    :src="course.image"
                  />
                  <v-icon
                    v-else
                    small
                  >
                    fas fa-user
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ course.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ course.price }} บาท
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click="removeCourse(course._id)"
                  >
                    <v-icon small>
                      fas fa-times
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
            <div v-else>
              <center>
                <v-icon left>
                  fas fa-dizzy
                </v-icon>
                ไม่มีบริการคอร์สที่คุณเลือก
              </center>
            </div>
          </v-list>
          <v-list
            subheader
            dense
            two-line
          >
            <v-subheader>บริการที่คุณเลือก</v-subheader>
            <div v-if="selectedService.length > 0">
              <v-list-item
                v-for="service in selectedService"
                :key="service._id"
              >
                <v-list-item-avatar color="orange">
                  <v-img
                    v-if="service.image"
                    :src="service.image"
                  />
                  <v-icon
                    v-else
                    small
                  >
                    fas fa-spa
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ service.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ service.price }} บาท
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click="removeService(service._id)"
                  >
                    <v-icon small>
                      fas fa-times
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </div>
            <div v-else>
              <center>
                <v-icon left>
                  fas fa-dizzy
                </v-icon>
                ไม่มีบริการที่คุณเลือก
              </center>
            </div>
          </v-list>
          <v-divider class="my-5" />
          <v-row dense>
            <v-col
              cols="12"
            >
              <v-dialog
                ref="dateModal"
                v-model="dateModal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    color="orange"
                    label="วันที่จอง"
                    prepend-inner-icon="fas fa-calendar-alt"
                    readonly
                    filled
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="date"
                  scrollable
                  color="orange"
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="orange"
                    @click="$refs.dateModal.save(date)"
                  >
                    ตกลง
                  </v-btn>
                  <v-btn
                    text
                    color="red"
                    @click="dateModal = false"
                  >
                    ยกเลิก
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="startTime"
                type="time"
                label="เวลาเริ่มต้น"
                color="orange"
                filled
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="endTime"
                type="time"
                label="เวลาสิ้นสุด"
                color="orange"
                filled
                readonly
              />
            </v-col>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="customerMark"
                label="หมายเหตุ"
                color="orange"
                filled
              />
            </v-col>
            <span class="red--text">*** ร้านเปิดทำการระหว่าง 10:00 ถึง 20:00 ***</span>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="orange"
            @click="createQueue"
          >
            จอง
          </v-btn>
          <v-btn
            text
            color="red"
            @click="bookDialog = false"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment';
import http from '@/http';

export default {
  name: 'ProductList',
  data() {
    return {
      selectedCourse: [],
      selectedService: [],
      courses: [],
      services: [],
      date: '',
      bookDialog: false,
      price: '',
      time: '',
      startTime: '',
      endTime: '',
      dateModal: false,
      customerMark: '',
    };
  },
  watch: {
    selectedService(value) {
      if (value) {
        this.calculate();
      }
    },
    selectedCourse(value) {
      if (value) {
        this.calculate();
      }
    },
    startTime(value) {
      const endTime = moment(`${this.date} ${value}`).add(this.time, 'minutes').format('HH:mm');
      this.endTime = endTime;
    },
  },
  async created() {
    const services = await http.get('/services?status=ACTIVE');
    this.services = [...services.data];
    const courses = await http.get('/courses?status=ACTIVE');
    this.courses = [...courses.data];
    const today = moment().format('YYYY-MM-DD');
    this.date = new Date(today).toISOString().substr(0, 10);
  },
  methods: {
    addToCart(data, type) {
      if (type === 'course') {
        this.selectedCourse.push(data);
      }
      if (type === 'service') {
        this.selectedService.push(data);
      }
    },
    calculate() {
      let time = 0;
      let value = 0;
      this.selectedService.forEach((data) => {
        // eslint-disable-next-line
        const service = this.services.find(element => element._id === data._id);
        if (service) {
          time += service.time;
          value += service.price;
        }
      });
      this.selectedCourse.forEach((data) => {
        // eslint-disable-next-line
        const course = this.courses.find(element => element._id === data._id);
        if (course) {
          time += course.time;
          value += course.price;
        }
      });
      this.price = value;
      this.time = time;
    },
    removeService(id) {
      // eslint-disable-next-line
      this.selectedService = this.selectedService.filter(service => service._id !== id);
    },
    removeCourse(id) {
      // eslint-disable-next-line
      this.selectedCourse = this.selectedCourse.filter(course => course._id !== id);
    },
    async createQueue() {
      const data = {
        // eslint-disable-next-line
        courses: this.selectedCourse.map(course => course._id),
        // eslint-disable-next-line
        services: this.selectedService.map(service => service._id),
        time: this.time,
        price: this.price,
        startDate: moment(`${this.date} ${this.startTime}`).valueOf(),
        endDate: moment(`${this.date} ${this.endTime}`).valueOf(),
        customerMark: this.customerMark,
      };
      await http.post('/reservations/customer', data);
      this.bookDialog = false;
      this.selectedCourse = [];
      this.selectedService = [];
      this.startTime = '';
      this.endTime = '';
      const today = moment().format('YYYY-MM-DD');
      this.date = new Date(today).toISOString().substr(0, 10);
    },
  },
};
</script>
